// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmoffboardingmgmtpg-inline-1 {
  padding: 0;
  overflow-x: auto;
}

.pmoffboardingmgmtpg-inline-2 {
  padding: 20px;
}

.pmoffboardingmgmtpg-inline-3 {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
}

.pmoffboardingmgmtpg-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.pmoffboardingmgmtpg-inline-5 {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.pmoffboardingmgmtpg-inline-6 {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 12px;
}

.pmoffboardingmgmtpg-inline-7 {
  margin-bottom: 8px;
}

.pmoffboardingmgmtpg-inline-8 {
  margin-bottom: 10px;
}

.pmoffboardingmgmtpg-inline-9 {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 6px;
}

.pmoffboardingmgmtpg-inline-10 {
  display: grid;
  grid-template-columns: 1fr 1fr 120px;
  gap: 8px;
  margin-bottom: 8px;
}

.pmoffboardingmgmtpg-inline-11 {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 8px;
}

.pmoffboardingmgmtpg-inline-12 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.pmoffboardingmgmtpg-inline-13 {
  position: fixed;
  inset: 0;
  background: rgba(2,6,23,.45);
  display: grid;
  place-items: center;
  z-index: 3000;
}

.pmoffboardingmgmtpg-inline-14 {
  width: min(1000px, 94vw);
  height: min(88vh, 760px);
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.pmoffboardingmgmtpg-inline-15 {
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pmoffboardingmgmtpg-inline-16 {
  font-weight: 700;
}

.pmoffboardingmgmtpg-inline-17 {
  width: 100%;
  height: 100%;
  border: 0;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMOffboardingMgmtPg.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX","sourcesContent":[".pmoffboardingmgmtpg-inline-1 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmoffboardingmgmtpg-inline-2 {\n  padding: 20px;\n}\n\n.pmoffboardingmgmtpg-inline-3 {\n  text-align: center;\n  padding: 20px;\n  color: #94a3b8;\n}\n\n.pmoffboardingmgmtpg-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.pmoffboardingmgmtpg-inline-5 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.pmoffboardingmgmtpg-inline-6 {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 10px;\n  font-size: 12px;\n}\n\n.pmoffboardingmgmtpg-inline-7 {\n  margin-bottom: 8px;\n}\n\n.pmoffboardingmgmtpg-inline-8 {\n  margin-bottom: 10px;\n}\n\n.pmoffboardingmgmtpg-inline-9 {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.pmoffboardingmgmtpg-inline-10 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 120px;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.pmoffboardingmgmtpg-inline-11 {\n  font-size: 11px;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.pmoffboardingmgmtpg-inline-12 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.pmoffboardingmgmtpg-inline-13 {\n  position: fixed;\n  inset: 0;\n  background: rgba(2,6,23,.45);\n  display: grid;\n  place-items: center;\n  z-index: 3000;\n}\n\n.pmoffboardingmgmtpg-inline-14 {\n  width: min(1000px, 94vw);\n  height: min(88vh, 760px);\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n}\n\n.pmoffboardingmgmtpg-inline-15 {\n  padding: 10px 12px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.pmoffboardingmgmtpg-inline-16 {\n  font-weight: 700;\n}\n\n.pmoffboardingmgmtpg-inline-17 {\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
